import { useLayoutEffect, useMemo } from 'react'
import { useElementSelectionStore, useSelectionStore } from '@editorStores'

const emptyArray: string[] = []

/**
 * Mirrors the current planar selection of the global selection store into the scene highlight
 * (`selectedStandAloneIds`) — the store-backed successor of `useHighlightFromParams`, which read
 * the former selection query params.
 */
const useHighlightFromSelection = (condition = true, additionalIds: string[] = emptyArray) => {
  const setSelectedStandaloneIds = useElementSelectionStore(state => state.setSelectedStandaloneIds)
  const selection = useSelectionStore(state => state.selection)

  const guids = selection?.type === 'planar' ? selection.guids : emptyArray

  const idsString = useMemo(
    () => JSON.stringify([...guids, ...additionalIds]),
    [guids, additionalIds],
  )

  useLayoutEffect(() => {
    if (!condition) return

    const ids: string[] = JSON.parse(idsString)

    if (ids.length) setSelectedStandaloneIds(ids)
    else setSelectedStandaloneIds([])

    return () => setSelectedStandaloneIds([])
  }, [idsString, condition, setSelectedStandaloneIds])
}

export default useHighlightFromSelection
